<form [formGroup]="form" class="flex flex-col gap-2 ">


    <div class="flex flex-col sm:flex-col md:flex-col lg:flex-row flex-1 gap-4">

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dense flex-1 w-full">
            <mat-label>Pad</mat-label>
            <mat-select formControlName="padSite">
                <mat-option *ngFor="let p of (pads$ | async)" [value]="p.name">
                    {{ p.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dense flex-1 w-full">
            <mat-label>Well</mat-label>
            <mat-select formControlName="drillOutTemplateId" [disabled]="!(wellsForPad$ | async)?.length">
                <mat-option *ngFor="let r of (wellsForPad$ | async)" [value]="r.id">
                    {{ r.wellSiteWithNumber }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dense flex-1">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="startDate" placeholder="Start date">
            <input matEndDate formControlName="endDate" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
</form>